export default __webpack_public_path__ + "static/media/party_emoji_animated.336595d9.gif";